import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/CruiseMakeup`
//#region select数据源相关api
const GetStatusList = `${apiUrl}/GetStatusList`
const GetList = `${apiUrl}`
const GetTasks = `${apiUrl}/tasks`
const Back = (id: number) => `${apiUrl}/back/${id}`
const Delete = (id: number) => `${apiUrl}/${id}`
const Get = (id: number) => `${apiUrl}/${id}`
const View = (id: number) => `${apiUrl}/view/${id}`
const Post = `${apiUrl}`
const Put = (id: number) => `${apiUrl}/${id}`
//#endregion
export const emptyCruiseMakeup: CruiseMakeupData = {
    DateRange: [],

    Id: 0,
    HeritageUnitId: 0,
    StartDate: new Date(),
    EndDate: new Date(),
    Status: 0,
    Comments: '',

    UnitCode: '',
    UnitName: '',

    AttachType: 0,
    AttachGuid: '',
    DetailList: []
}
export interface CruiseMakeupData {
    DateRange: string[]

    Id: number
    HeritageUnitId: number
    StartDate: Date
    EndDate: Date
    Status: number
    Comments: string

    UnitCode: string
    UnitName: string
    AttachType: number
    AttachGuid: string

    DetailList: CruiseMakeupDetailData[]
}
export interface CruiseMakeupDetailData {
    Id: number
    MakeupId: number
    HeritageCruisePointId: number
    Status: number
    Comments: string

    CruiseId: number
    PointName: string
    PointDesc: string

    SubList: CruiseMakeupSubDetailData[]
}
export interface CruiseMakeupSubDetailData {
    Checked: boolean
    Id: number
    MakeupDetailId: number
    TaskDetailId: number
    TaskCruiserId: number
    Status: number

    PlanId: number
    PlanName: string
    PlanType: number
    ScheduleId: number
    ScheduleName: string

    StartDate: Date
    EndDate: Date
    DetailStatus: number
}
export const getStatusList = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetStatusList,
        params: { type: firstType }
    })
}
export const getList = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}
export const getTasks = (param?: any) => {
    return tryAxios({
        method: 'get',
        url: GetTasks,
        params: param
    })
}
export const removeData = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}
export const backData = (id: number) => {
    return tryAxios({
        method: 'post',
        url: Back(id)
    })
}
export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: Get(id)
    })
}
export const viewInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: View(id)
    })
}
export const postData = (form: any) => {
    return tryAxios({
        method: 'post',
        url: Post,
        data: form
    })
}
export const putData = (id: number, form: any) => {
    return tryAxios({
        method: 'put',
        url: Put(id),
        data: form
    })
}